
// import React, { useState, useEffect, useRef } from "react";
// import { message, Modal } from "antd";
// import AIReportUpload from "../Quantum/AIReportUpload";
// import ReportUploadProgress from "../Quantum/ReportUploadProgress";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import { startGlobalUpload } from "../../auth/utils/globalUploader";

// const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
// const log = (event, payload) => {
//   try { console.log("[LungsCareUpload]", event, payload || ""); } catch {}
// };
// const resolveFileType = (selectedFile) => {
//   const mimeToExt = (m) => (
//     m === "audio/wav" ? ".wav" :
//     m === "audio/mp4" ? ".m4a" :
//     ""
//   );
//   const extFromName = selectedFile?.name?.includes(".") ? "." + selectedFile.name.split(".").pop().toLowerCase() : "";
//   const ct = selectedFile?.type || "application/octet-stream";
//   return extFromName || mimeToExt(ct);
// };

// export default function LungsCareUpload({ patientId, serviceName = "Lung Care", onStarted, initialVisible, onCloseInitial }) {
//   const [file, setFile] = useState(null);
//   const [requestId, setRequestId] = useState(null);
//   const [uploadUrls, setUploadUrls] = useState([]);
//   const [stage, setStage] = useState(initialVisible ? "instructions" : null);
//   const [progress, setProgress] = useState(0);
//   const [errorText, setErrorText] = useState("");
//   const [isRecording, setIsRecording] = useState(false);
//   const [countdown, setCountdown] = useState(0);
//   const countdownRef = useRef(null);
//   const isCancelledRef = useRef(false);
//   const mediaRecorderRef = useRef(null);
//   const chunksRef = useRef([]);
//   const [recordedBlob, setRecordedBlob] = useState(null);
//   const navigate = useNavigate();

//   const endpointBase = process.env.REACT_APP_QUANTUMURL;

//   useEffect(() => {
//     if (initialVisible) {
//       setStage("instructions");
//       log("initial_modal_open");
//     }
//   }, [initialVisible]);

//   const generateUploadUrl = async (ct, selectedFile) => {
//     setProgress(10);
//     try { localStorage.setItem("quantumUploadSession", JSON.stringify({ requestId: null, serviceName, progress: 10, checkedOnce: false })); } catch {}
//     setStage("ai");
//     log("ai_modal_open");
//     const resolvedFileType = resolveFileType(selectedFile);
//     const payload = {
//       patientId,
//       serviceName,
//       files: [
//         {
//           fileNumber: 1,
//           fileType: resolvedFileType,
//           contentType: ct,
//         }
//       ]
//     };
//     try {
//       log("prepare_upload_start", payload);
//       await delay(10000);
//       const url = new URL("new_generate-resumable-url", endpointBase).toString();
//       const res = await axios.post(url, payload, { headers: { "Content-Type": "application/json" } });
//       const data = res.data;
//       const rid = data?.request_id || data?.requestId || data?.requestid || data?.requestID || null;
//       setRequestId(rid);
//       setUploadUrls(data?.upload_urls || []);
//       setProgress(50);
//       try {
//         const sess = JSON.parse(localStorage.getItem("quantumUploadSession") || "{}");
//         localStorage.setItem("quantumUploadSession", JSON.stringify({ ...sess, requestId: rid, serviceName, progress: 50 }));
//       } catch {}
//       setStage("progress");
//       log("ai_modal_close");
//       log("progress_modal_open");
//       setErrorText("");
//       log("prepare_upload_success", { requestId: rid });
//       return { rid, urls: data?.upload_urls || [] };
//     } catch (err) {
//       setErrorText(String(err));
//       message.error("Failed to prepare upload. Please try again.");
//       setStage("ai");
//       log("prepare_upload_error", { message: String(err) });
//       localStorage.removeItem("quantumUploadSession");
//       return Promise.reject(err);
//     }
//   };

//   const uploadFile = async (urlsParam, fileParam) => {
//     const urls = Array.isArray(urlsParam) ? urlsParam : uploadUrls;
//     const useFile = fileParam || file;
//     if (!urls.length || !useFile) return;
//     setStage("progress");
//     log("progress_modal_open");
//     const ct = useFile?.type || "application/octet-stream";
//     try {
//       log("upload_put_start", { url: urls[0]?.url, contentType: ct });
//       await delay(10000);
//       await axios.put(urls[0].url, useFile, {
//         headers: { "Content-Type": ct },
//         timeout: 60000,
//         onUploadProgress: (evt) => {
//           if (evt && typeof evt.loaded === "number" && typeof evt.total === "number" && evt.total > 0) {
//             const fraction = evt.loaded / evt.total;
//             const pct = 50 + Math.min(30, Math.round(fraction * 30));
//             setProgress(pct);
//             try {
//               const sess = JSON.parse(localStorage.getItem("quantumUploadSession") || "{}");
//               localStorage.setItem("quantumUploadSession", JSON.stringify({ ...sess, progress: pct }));
//             } catch {}
//             log("upload_progress", { percent: pct });
//           }
//         },
//       });
//       setProgress(80);
//       try { const sess = JSON.parse(localStorage.getItem("quantumUploadSession") || "{}"); localStorage.setItem("quantumUploadSession", JSON.stringify({ ...sess, progress: 80 })); } catch {}
//       setErrorText("");
//       log("upload_put_success");
//     } catch (err) {
//       setErrorText(String(err));
//       log("upload_put_error", { message: String(err) });
//       localStorage.removeItem("quantumUploadSession");
//       throw err;
//     }
//   };

//   const checkUploaded = async (ridOverride) => {
//     const rid = ridOverride || requestId;
//     if (!rid) return;
//     setProgress((p) => (p < 90 ? 90 : p));
//     try { const sess = JSON.parse(localStorage.getItem("quantumUploadSession") || "{}"); localStorage.setItem("quantumUploadSession", JSON.stringify({ ...sess, progress: 90 })); } catch {}
//     const url = new URL("check-uploaded-files", endpointBase).toString();
//     const body = {
//       requestId: rid,
//       serviceName,
//       signedUrlCount: 1,
//       fileType: resolveFileType(file),
//     };
//     try {
//       log("verify_start", { requestId: rid });
//       await delay(10000);
//       const res = await axios.post(url, body, { headers: { "Content-Type": "application/json", accept: "application/json" } });
//       const data = res.data;
//       log("verify_response", data);
//       if (data) {
//         setProgress(100);
//         try { const sess = JSON.parse(localStorage.getItem("quantumUploadSession") || "{}"); localStorage.setItem("quantumUploadSession", JSON.stringify({ ...sess, progress: 100 })); } catch {}
//         setErrorText("");
//         log("verify_success", { requestId: rid });
//       } else {
//         setErrorText("Upload verification failed.");
//         message.error("Upload verification failed.");
//         log("verify_failed", { status: data?.status });
//       }
//     } catch (err) {
//       setErrorText(String(err));
//       message.error("Failed to verify upload.");
//       log("verify_error", { message: String(err) });
//       localStorage.removeItem("quantumUploadSession");
//       throw err;
//     }
//   };

//   const handleMicStop = (rb) => {
//     try { message.destroy(); } catch {}
//     setIsRecording(false);
//     setCountdown(0);
//     clearInterval(countdownRef.current);
//     const blob = rb?.blob || null;
//     if (!blob) { message.error("No audio captured"); return; }
//     setRecordedBlob(blob);
//     const wavFile = new File([blob], "lung-test.wav", { type: "audio/wav" });
//     setFile(wavFile);
//     setStage("ai");
//     if (typeof onStarted === "function") onStarted();

//     // Use global uploader so the upload survives page navigation.
//     // The banner in GlobalAIReportProgressBanner will take over if the
//     // user navigates away before the upload completes.
//     startGlobalUpload({
//       file: wavFile,
//       serviceName,
//       patientId,
//       endpointBase: process.env.REACT_APP_QUANTUMURL,
//       onProgress: (pct) => {
//         setProgress(pct);
//         if (pct >= 50) setStage("progress");
//       },
//       onSuccess: () => {
//         setProgress(100);
//         setStage("progress");
//       },
//       onError: () => {
//         setProgress(0);
//         setStage("ai");
//         setErrorText("Upload failed. Please try again.");
//         localStorage.removeItem("quantumUploadSession");
//       },
//     });
//   };

//   const startRecording = () => {
//     if (isRecording) return;
//     isCancelledRef.current = false;
//     setRecordedBlob(null);
//     chunksRef.current = [];

//     navigator.mediaDevices.getUserMedia({ audio: true })
//       .then((stream) => {
//         const recorder = new MediaRecorder(stream);
//         mediaRecorderRef.current = recorder;

//         recorder.ondataavailable = (e) => {
//           if (e.data.size > 0) chunksRef.current.push(e.data);
//         };

//         recorder.onstop = () => {
//           stream.getTracks().forEach((t) => t.stop());
//           if (isCancelledRef.current) return;
//           const blob = new Blob(chunksRef.current, { type: "audio/wav" });
//           handleMicStop({ blob });
//         };

//         recorder.start();
//         setIsRecording(true);
//         setCountdown(10);
//         try { message.loading("Recording audio for 10 seconds...", 10); } catch {}

//         countdownRef.current = setInterval(() => {
//           setCountdown((prev) => {
//             if (prev <= 1) { clearInterval(countdownRef.current); return 0; }
//             return prev - 1;
//           });
//         }, 1000);

//         setTimeout(() => {
//           if (recorder.state !== "inactive") recorder.stop();
//           setIsRecording(false);
//         }, 10000);
//       })
//       .catch(() => {
//         message.error("Microphone access denied. Please allow microphone permissions and try again.");
//       });
//   };

//   return (
//     <>
//       <Modal
//   open={stage === "instructions"}
//   onCancel={() => {
//     isCancelledRef.current = true;
//     if (mediaRecorderRef.current && mediaRecorderRef.current.state !== "inactive") {
//       mediaRecorderRef.current.stop();
//     }
//     setStage(null);
//     setIsRecording(false);
//     clearInterval(countdownRef.current);
//     message.destroy();
//     log("initial_modal_cancel");
//     if (typeof onCloseInitial === "function") onCloseInitial();
//   }}
//   footer={null}
//   centered
//   width={600}
//   style={{ maxWidth: "100vw" }}
//   title={
//     <span
//       style={{
//         background: "var(--primary-gradient)",
//         WebkitBackgroundClip: "text",
//         WebkitTextFillColor: "transparent",
//         backgroundClip: "text",
//         fontFamily: "Inter, sans-serif",
//         fontSize: "28px",
//         fontWeight: 600,
//         lineHeight: "100%",
//         letterSpacing: "0px",
//       }}
//     >
//       Upload cough audio & get an instant result
//     </span>
//   }
// >
//   <div className="flex flex-col md:flex-row gap-6 mt-4">
//     <ul className="list-disc pl-5 flex-1 space-y-2">
//       {[
//         "Find a quiet place with minimal background noise.",
//         "Hold your phone 6–8 inches away from your mouth.",
//         "Tap Record to begin capturing your cough sound.",
//         "Cough directly into the microphone.",
//         "Record for the full 10 seconds.",
//         "Only one person should cough during the test.",
//       ].map((text, idx) => (
//         <li
//           key={idx}
//           style={{
//             fontFamily: "Inter, sans-serif",
//             fontSize: "15px",
//             fontWeight: 400,
//             lineHeight: "100%",
//             letterSpacing: "0px",
//             color: "#09048C",
//           }}
//         >
//           {text}
//         </li>
//       ))}
//     </ul>

//     <div className="flex flex-col items-center gap-3 flex-1">
//       <div
//         className={`h-48 w-48 ${isRecording ? "bg-red-100" : "bg-gray-200"} rounded flex items-center justify-center text-2xl font-bold`}
//       >
//         {isRecording ? `${countdown}s` : "Microphone Idle"}
//       </div>

//       <button
//         onClick={startRecording}
//         disabled={isRecording}
//         style={{
//           padding: "8px 12px",
//           background: isRecording ? "#c46abf" : "#8E0186",
//           color: "#ffffff",
//           fontFamily: "Inter, sans-serif",
//           fontSize: "14px",
//           fontWeight: 500,
//           border: "none",
//           borderRadius: "6px",
//           cursor: isRecording ? "not-allowed" : "pointer",
//           opacity: isRecording ? 0.7 : 1,
//         }}
//       >
//         {isRecording ? "Recording..." : "Start Upload"}
//       </button>

//       {isRecording && (
//         <div className="w-full h-8 bg-gray-100 rounded flex items-center justify-center text-xs text-gray-400 animate-pulse">
//           🎙 Recording in progress...
//         </div>
//       )}
//     </div>
//   </div>
// </Modal>

//       <AIReportUpload
//         solutionType="lunge_care"
//         visible={stage === "ai"}
//         customHeaderTitle={errorText ? "Image upload failed !" : undefined}
//         customHeaderColor={errorText ? "#FA0505" : undefined}
//         customTitle={errorText ? "Oops, we couldn't upload your image. Please check your connection and try uploading again so our AI can generate your report." : undefined}
//         customDescription={errorText ? "Your image upload was unsuccessful-please upload the photo again !" : undefined}
//         customDescriptionColor={errorText ? "#FA0505" : undefined}
//         customButtonText={errorText ? "Upload Again" : undefined}
//         onCancel={() => {
//           setStage(null);
//           log("ai_modal_cancel");
//           setErrorText("");
//         }}
//         onExplore={() => {
//           if (errorText) {
//             setStage("instructions");
//             setErrorText("");
//             return;
//           }
//           navigate("/");
//           log("ai_modal_explore");
//         }}
//         onWait={() => { setStage("progress"); log("ai_modal_wait"); log("progress_modal_open"); }}
//       />

//       <ReportUploadProgress
//         solutionType="lung_care"
//         visible={stage === "progress"}
//         onCancel={() => { setStage(null); log("progress_modal_cancel"); }}
//         progress={progress}
//         title={errorText ? "Upload failed" : undefined}
//         description={errorText ? errorText : undefined}
//         analyzingText={errorText ? "Please close and retry" : undefined}
//         onView={() => {
//           navigate("/aireports", { state: { tab: "lungs_care" } });
//           log("progress_modal_view_report", { tab: "lungs_care" });
//           localStorage.removeItem("quantumUploadSession");
//         }}
//       />
//     </>
//   );
// }


import React, { useState, useEffect, useRef } from "react";
import { message, Modal } from "antd";
import AIReportUpload from "../Quantum/AIReportUpload";
import ReportUploadProgress from "../Quantum/ReportUploadProgress";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
const log = (event, payload) => {
  try { console.log("[LungsCareUpload]", event, payload || ""); } catch {}
};
const resolveFileType = (selectedFile) => {
  const mimeToExt = (m) => (
    m === "audio/wav" ? ".wav" :
    m === "audio/mp4" ? ".m4a" :
    ""
  );
  const extFromName = selectedFile?.name?.includes(".") ? "." + selectedFile.name.split(".").pop().toLowerCase() : "";
  const ct = selectedFile?.type || "application/octet-stream";
  return extFromName || mimeToExt(ct);
};

export default function LungsCareUpload({ patientId, sourcechannel, createdBy,serviceName = "Lung Care", onStarted, initialVisible, onCloseInitial }) {
  const [file, setFile] = useState(null);
  const [requestId, setRequestId] = useState(null);
  const [uploadUrls, setUploadUrls] = useState([]);
  const [stage, setStage] = useState(initialVisible ? "instructions" : null);
  const [progress, setProgress] = useState(0);
  const [errorText, setErrorText] = useState("");
  const [isRecording, setIsRecording] = useState(false);
  const [countdown, setCountdown] = useState(0);
  const countdownRef = useRef(null);
  const isCancelledRef = useRef(false);
  const mediaRecorderRef = useRef(null);
  const chunksRef = useRef([]);
  const [recordedBlob, setRecordedBlob] = useState(null);
  const navigate = useNavigate();

  const endpointBase = process.env.REACT_APP_QUANTUMURL;

  useEffect(() => {
    if (initialVisible) {
      setStage("instructions");
      log("initial_modal_open");
    }
  }, [initialVisible]);

  const generateUploadUrl = async (ct, selectedFile) => {
    setProgress(10);
    try { localStorage.setItem("quantumUploadSession", JSON.stringify({ requestId: null, serviceName, progress: 10, checkedOnce: false })); } catch {}
    setStage("ai");
    log("ai_modal_open");
    const resolvedFileType = resolveFileType(selectedFile);
    const payload = {
      patientId,
      serviceName,
      files: [
        {
          fileNumber: 1,
          fileType: resolvedFileType,
          contentType: ct,
        }
      ]
    };
    try {
      log("prepare_upload_start", payload);
      await delay(10000);
      const url = new URL("new_generate-resumable-url", endpointBase).toString();
      const res = await axios.post(url, payload, { headers: { "Content-Type": "application/json" } });
      const data = res.data;
      const rid = data?.request_id || data?.requestId || data?.requestid || data?.requestID || null;
      setRequestId(rid);
      setUploadUrls(data?.upload_urls || []);
      setProgress(50);
      try {
        const sess = JSON.parse(localStorage.getItem("quantumUploadSession") || "{}");
        localStorage.setItem("quantumUploadSession", JSON.stringify({ ...sess, requestId: rid, serviceName, progress: 50 }));
      } catch {}
      setStage("progress");
      log("ai_modal_close");
      log("progress_modal_open");
      setErrorText("");
      log("prepare_upload_success", { requestId: rid });
      return { rid, urls: data?.upload_urls || [] };
    } catch (err) {
      setErrorText(String(err));
      message.error("Failed to prepare upload. Please try again.");
      setStage("ai");
      log("prepare_upload_error", { message: String(err) });
      localStorage.removeItem("quantumUploadSession");
      return Promise.reject(err);
    }
  };

  const uploadFile = async (urlsParam, fileParam) => {
    const urls = Array.isArray(urlsParam) ? urlsParam : uploadUrls;
    const useFile = fileParam || file;
    if (!urls.length || !useFile) return;
    setStage("progress");
    log("progress_modal_open");
    const ct = useFile?.type || "application/octet-stream";
    try {
      log("upload_put_start", { url: urls[0]?.url, contentType: ct });
      await delay(10000);
      await axios.put(urls[0].url, useFile, {
        headers: { "Content-Type": ct },
        timeout: 60000,
        onUploadProgress: (evt) => {
          if (evt && typeof evt.loaded === "number" && typeof evt.total === "number" && evt.total > 0) {
            const fraction = evt.loaded / evt.total;
            const pct = 50 + Math.min(30, Math.round(fraction * 30));
            setProgress(pct);
            try {
              const sess = JSON.parse(localStorage.getItem("quantumUploadSession") || "{}");
              localStorage.setItem("quantumUploadSession", JSON.stringify({ ...sess, progress: pct }));
            } catch {}
            log("upload_progress", { percent: pct });
          }
        },
      });
      setProgress(80);
      try { const sess = JSON.parse(localStorage.getItem("quantumUploadSession") || "{}"); localStorage.setItem("quantumUploadSession", JSON.stringify({ ...sess, progress: 80 })); } catch {}
      setErrorText("");
      log("upload_put_success");
    } catch (err) {
      setErrorText(String(err));
      log("upload_put_error", { message: String(err) });
      localStorage.removeItem("quantumUploadSession");
      throw err;
    }
  };

  const checkUploaded = async (ridOverride) => {
    const rid = ridOverride || requestId;
    if (!rid) return;
    setProgress((p) => (p < 90 ? 90 : p));
    try { const sess = JSON.parse(localStorage.getItem("quantumUploadSession") || "{}"); localStorage.setItem("quantumUploadSession", JSON.stringify({ ...sess, progress: 90 })); } catch {}
    const url = new URL("check-uploaded-files", endpointBase).toString();
    const body = {
      requestId: rid,
      serviceName,
      sourceChannel: sourcechannel,  
        createdBy: createdBy,
      signedUrlCount: 1,
      fileType: resolveFileType(file),
    };
    try {
      log("verify_start", { requestId: rid });
      await delay(10000);
      const res = await axios.post(url, body, { headers: { "Content-Type": "application/json", accept: "application/json" } });
      const data = res.data;
      log("verify_response", data);
      if (data) {
        setProgress(100);
        try { const sess = JSON.parse(localStorage.getItem("quantumUploadSession") || "{}"); localStorage.setItem("quantumUploadSession", JSON.stringify({ ...sess, progress: 100 })); } catch {}
        setErrorText("");
        log("verify_success", { requestId: rid });
      } else {
        setErrorText("Upload verification failed.");
        message.error("Upload verification failed.");
        log("verify_failed", { status: data?.status });
      }
    } catch (err) {
      setErrorText(String(err));
      message.error("Failed to verify upload.");
      log("verify_error", { message: String(err) });
      localStorage.removeItem("quantumUploadSession");
      throw err;
    }
  };

  const handleMicStop = (rb) => {
    try { message.destroy(); } catch {}
    setIsRecording(false);
    setCountdown(0);
    clearInterval(countdownRef.current);
    const blob = rb?.blob || null;
    if (!blob) { message.error("No audio captured"); return; }
    setRecordedBlob(blob);
    const wavFile = new File([blob], "lung-test.wav", { type: "audio/wav" });
    setFile(wavFile);
    setStage("ai");
    if (typeof onStarted === "function") onStarted();
    const ct = "audio/wav";
    generateUploadUrl(ct, wavFile)
      .then(({ rid, urls }) => uploadFile(urls, wavFile).then(() => rid))
      .then((rid) => checkUploaded(rid))
      .catch(() => { setProgress(0); setStage("ai"); localStorage.removeItem("quantumUploadSession"); });
  };

  const startRecording = () => {
    if (isRecording) return;
    isCancelledRef.current = false;
    setRecordedBlob(null);
    chunksRef.current = [];

    navigator.mediaDevices.getUserMedia({ audio: true })
      .then((stream) => {
        const recorder = new MediaRecorder(stream);
        mediaRecorderRef.current = recorder;

        recorder.ondataavailable = (e) => {
          if (e.data.size > 0) chunksRef.current.push(e.data);
        };

        recorder.onstop = () => {
          stream.getTracks().forEach((t) => t.stop());
          if (isCancelledRef.current) return;
          const blob = new Blob(chunksRef.current, { type: "audio/wav" });
          handleMicStop({ blob });
        };

        recorder.start();
        setIsRecording(true);
        setCountdown(10);
        try { message.loading("Recording audio for 10 seconds...", 10); } catch {}

        countdownRef.current = setInterval(() => {
          setCountdown((prev) => {
            if (prev <= 1) { clearInterval(countdownRef.current); return 0; }
            return prev - 1;
          });
        }, 1000);

        setTimeout(() => {
          if (recorder.state !== "inactive") recorder.stop();
          setIsRecording(false);
        }, 10000);
      })
      .catch(() => {
        message.error("Microphone access denied. Please allow microphone permissions and try again.");
      });
  };

  return (
    <>
      <Modal
  open={stage === "instructions"}
  onCancel={() => {
    isCancelledRef.current = true;
    if (mediaRecorderRef.current && mediaRecorderRef.current.state !== "inactive") {
      mediaRecorderRef.current.stop();
    }
    setStage(null);
    setIsRecording(false);
    clearInterval(countdownRef.current);
    message.destroy();
    log("initial_modal_cancel");
    if (typeof onCloseInitial === "function") onCloseInitial();
  }}
  footer={null}
  centered
  width={600}
  style={{ maxWidth: "100vw" }}
  title={
    <span
      style={{
        background: "var(--primary-gradient)",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        backgroundClip: "text",
        fontFamily: "Inter, sans-serif",
        fontSize: "28px",
        fontWeight: 600,
        lineHeight: "100%",
        letterSpacing: "0px",
      }}
    >
      Upload cough audio & get an instant result
    </span>
  }
>
  <div className="flex flex-col md:flex-row gap-6 mt-4">
    <ul className="list-disc marker:text-[#004276] pl-5 flex-1 space-y-2">
      {[
        "Find a quiet place with minimal background noise.",
        "Hold your phone 6–8 inches away from your mouth.",
        "Tap Record to begin capturing your cough sound.",
        "Cough directly into the microphone.",
        "Record for the full 10 seconds.",
        "Only one person should cough during the test.",
      ].map((text, idx) => (
        <li
          key={idx}
          style={{
            fontFamily: "Inter, sans-serif",
            fontSize: "15px",
            fontWeight: 400,
            lineHeight: "100%",
            letterSpacing: "0px",
            color: "var(--color-text-subheading)",
          }}
        >
          {text}
        </li>
      ))}
    </ul>

    <div className="flex flex-col items-center gap-3 flex-1">
      <div
        className={`h-48 w-48 ${isRecording ? "bg-red-100" : "bg-gray-200"} rounded flex items-center justify-center text-2xl font-bold`}
      >
        {isRecording ? `${countdown}s` : "Microphone Idle"}
      </div>

      <button
        onClick={startRecording}
        disabled={isRecording}
        style={{
          padding: "8px 12px",
          background: isRecording ? "#80A1BB" : "var(--color-brand-primary)",
          color: "#ffffff",
          fontFamily: "Inter, sans-serif",
          fontSize: "14px",
          fontWeight: 500,
          border: "none",
          borderRadius: "6px",
          cursor: isRecording ? "not-allowed" : "pointer",
          opacity: isRecording ? 0.7 : 1,
        }}
      >
        {isRecording ? "Recording..." : "Start Upload"}
      </button>

      {isRecording && (
        <div className="w-full h-8 bg-gray-100 rounded flex items-center justify-center text-xs text-gray-400 animate-pulse">
          🎙 Recording in progress...
        </div>
      )}
    </div>
  </div>
</Modal>

      <AIReportUpload
        solutionType="lunge_care"
        visible={stage === "ai"}
        customHeaderTitle={errorText ? "Image upload failed !" : undefined}
        customHeaderColor={errorText ? "#FA0505" : undefined}
        customTitle={errorText ? "Oops, we couldn't upload your image. Please check your connection and try uploading again so our AI can generate your report." : undefined}
        customDescription={errorText ? "Your image upload was unsuccessful-please upload the photo again !" : undefined}
        customDescriptionColor={errorText ? "#FA0505" : undefined}
        customButtonText={errorText ? "Upload Again" : undefined}
        onCancel={() => {
          setStage(null);
          log("ai_modal_cancel");
          setErrorText("");
          try {
            const sess = JSON.parse(localStorage.getItem("quantumUploadSession") || "{}");
            localStorage.setItem("quantumUploadSession", JSON.stringify({ ...sess, checkedOnce: true }));
          } catch {}
        }}
        onExplore={() => {
          if (errorText) {
            setStage("instructions");
            setErrorText("");
            return;
          }
          const session = { requestId, serviceName, progress: progress || 10 };
          try { localStorage.setItem("quantumUploadSession", JSON.stringify({ ...session, checkedOnce: true })); } catch {}
          navigate("/", { state: { quantumUpload: session } });
          log("ai_modal_explore", session);
        }}
        onWait={() => { setStage("progress"); log("ai_modal_wait"); log("progress_modal_open"); }}
      />

      <ReportUploadProgress
        solutionType="lung_care"
        visible={stage === "progress"}
        onCancel={() => { setStage(null); log("progress_modal_cancel"); }}
        progress={progress}
        title={errorText ? "Upload failed" : undefined}
        description={errorText ? errorText : undefined}
        analyzingText={errorText ? "Please close and retry" : undefined}
        onView={() => {
          navigate("/aireports", { state: { tab: "lungs_care" } });
          log("progress_modal_view_report", { tab: "lungs_care" });
          localStorage.removeItem("quantumUploadSession");
        }}
      />
    </>
  );
}